import { render } from "./contentsAiView.vue?vue&type=template&id=7a30c1df"
import script from "./contentsAiView.vue?vue&type=script&lang=js"
export * from "./contentsAiView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/hooeni/Workspace/eduwind-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__